import { createClient } from '@/shared/api';
import type {
  MarkAllClinicNotificationsAsReadMutation,
  MarkAllClinicNotificationsAsReadMutationVariables,
} from '@/shared/api';
import MARK_ALL_CLINIC_NOTIFICATIONS_AS_READ from '../mutations/markAllClinicNotificationsAsRead';

/**
 * Marks every clinic notification of the current user as read. Runs the markAllClinicNotificationsAsRead mutation and throws either the first GraphQL error or the returned message when it does not report success.
 *
 * @returns A promise resolving once the notifications have been marked read.
 */
const handleMarkAllClinicNotificationsAsRead = async () => {
  const client = createClient();
  const result = await client.mutate<
    MarkAllClinicNotificationsAsReadMutation,
    MarkAllClinicNotificationsAsReadMutationVariables
  >({
    mutation: MARK_ALL_CLINIC_NOTIFICATIONS_AS_READ,
  });
  const { data, errors } = result;
  if (errors?.length) {
    throw new Error(errors[0].message);
  }
  // data is always present once the errors check above has passed
  const { markAllClinicNotificationsAsRead } = data!;
  if (!markAllClinicNotificationsAsRead?.isSuccess) {
    throw new Error(markAllClinicNotificationsAsRead?.message ?? undefined);
  }
};

export default handleMarkAllClinicNotificationsAsRead;
